import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React from 'react';
import { nanoid } from 'nanoid/non-secure';
import { forwardRef } from '../../system/forwardRef.es.js';
import { omitSystemProps, getSystemProps } from '../../system/styled-system.es.js';
import { Stack } from '../Stack/Stack.es.js';
import { Radio as Radio$2, Control, Label, Description } from './styled.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var Radio = forwardRef(function (props, ref) {
  var _a = omitSystemProps(props),
      idProp = _a.id,
      _a$as = _a.as,
      as = _a$as === void 0 ? "input" : _a$as,
      name = _a.name,
      value = _a.value,
      label = _a.label,
      description = _a.description,
      isChecked = _a.isChecked,
      isDisabled = _a.isDisabled,
      isInvalid = _a.isInvalid,
      onChange = _a.onChange,
      _a$hideLabel = _a.hideLabel,
      hideLabel = _a$hideLabel === void 0 ? false : _a$hideLabel,
      truncate = _a.truncate,
      defaultChecked = _a.defaultChecked,
      _a$size = _a.size,
      size = _a$size === void 0 ? "md" : _a$size,
      wrapperProps = _a.wrapperProps,
      wrapperRef = _a.wrapperRef,
      rest = __objRest(_a, ["id", "as", "name", "value", "label", "description", "isChecked", "isDisabled", "isInvalid", "onChange", "hideLabel", "truncate", "defaultChecked", "size", "wrapperProps", "wrapperRef"]);

  var _b = getSystemProps(props),
      systemProps = __objRest(_b, ["color"]);

  var id = idProp || "radio-" + nanoid();
  return (
    /* @__PURE__ */
    React.createElement(Radio$2, __spreadValues({
      ref: ref,
      forwardedAs: as,
      id: id,
      name: name,
      value: value,
      onChange: onChange,
      isChecked: isChecked,
      isDisabled: isDisabled,
      isInvalid: isInvalid,
      wrapperProps: __spreadValues(__spreadValues({}, wrapperProps), systemProps)
    }, rest),
    /* @__PURE__ */
    React.createElement(Control, {
      size: size
    }),
    /* @__PURE__ */
    React.createElement(Stack, {
      gutter: "xxs",
      ml: "xs"
    }, !hideLabel &&
    /* @__PURE__ */
    React.createElement(Label, {
      size: size,
      isDisabled: isDisabled,
      nbOfLines: truncate ? 1 : void 0
    }, label), !!description &&
    /* @__PURE__ */
    React.createElement(Description, null, description)))
  );
});
Radio.displayName = "Radio";
var Radio$1 = Object.assign(Radio, {
  Root: Radio$2,
  Control: Control,
  Label: Label,
  Description: Description
});
export { Radio$1 as default };